import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quests/active-quests')({
  beforeLoad: async ({ search, location }) => {
    search.quests = 'active-quests'
    throw redirect({
      to: '/',
      search,
      state: {
        ...location.state,
        from: 'deeplink',
      },
    })
  },
})
